import { UserAuth } from '@textile/hub'
import { Libp2pCryptoIdentity } from '@textile/threads'

export const userCookie = 'user'

export type UserCookie = {
  userAuth: UserAuth
  identity: Libp2pCryptoIdentity
}
